/**
 * Strings of the poke screens (2026-10-29): the sticky pop-up stack, its
 * alert (the buzz, the title, the OS notification) and its settings, and the
 * role editor's "Who can poke members with this role".
 */
import type { Dict } from './core';

export const pokesEn: Dict = {
  // the stack
  'pk.stack': 'Pokes',
  'pk.count': { one: '{n} poke', other: '{n} pokes' },
  'pk.closeAll': 'Close all',
  'pk.close': 'Close',
  'pk.reply': 'Reply',
  'pk.got': 'poked you',
  'pk.noMessage': 'No message',
  // the alert outside the app
  'pk.title': 'Poke from {who}',
  'pk.os.title': '{who} poked you',
  'pk.os.body': 'Open the app to answer.',
  // Settings > Notifications
  'pk.set.group': 'Pokes',
  'pk.set.buzz': 'Buzz when poked',
  'pk.set.buzzSub':
    'A loud buzz, and a vibration on phones. Pokes always pop up until you close them.',
  'pk.set.volume': 'Buzz volume',
  'pk.set.preview': 'Play the buzz',
  // Server settings > Roles
  'pk.role.label': 'Who can poke members with this role',
  'pk.role.everyone': 'Everyone with Poke',
  'pk.role.higher': 'Only higher roles',
  'pk.role.nobody': 'Nobody',
  'pk.role.help': 'Their highest role decides. The owner can always poke.',
  'pk.role.needPoke': 'Only members with the Poke members permission can change this.',
};
